import React from 'react';
import { DayReports } from '../components/day_report';

export function DayReport({ setActiveItem }: { setActiveItem: (item: string) => void }) {
  return <DayReports setActiveItem={setActiveItem} />;
}
